import { useState } from 'react'
import { Link } from '@tanstack/react-router'
import { Menu } from 'lucide-react'

import { primaryNav } from '@/config/nav'
import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { NavLink } from '@/components/layout/nav-link'

function MobileNav() {
  const [open, setOpen] = useState(false)

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="md:hidden" aria-label="Open menu">
          <Menu className="size-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-72">
        <SheetHeader>
          <SheetTitle>Menu</SheetTitle>
        </SheetHeader>
        <nav aria-label="Primary" className="flex flex-col gap-1 px-4">
          {primaryNav.map((item) => (
            <SheetClose asChild key={item.href}>
              <NavLink
                to={item.href}
                className="text-foreground hover:bg-muted rounded-md px-2 py-2 text-base font-medium"
              >
                {item.label}
              </NavLink>
            </SheetClose>
          ))}
        </nav>
        <div className="border-border mt-4 flex flex-col gap-2 border-t px-4 pt-4">
          <SheetClose asChild>
            <Button asChild size="sm">
              <Link to={'/play' as never}>Play now</Link>
            </Button>
          </SheetClose>
        </div>
      </SheetContent>
    </Sheet>
  )
}

export { MobileNav }
